import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, Shield, Users, Upload, Eye, Lock } from "lucide-react";
import LoginModal from "../components/LoginModal";
import { useAuth } from "../context/AuthContext";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../utils/fireBase";

const LandingPage = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("user");
  const { isAuthenticated, user } = useAuth();
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setShowLoginModal(true);
  };
  useEffect(() => {
    if (isAuthenticated) {
      navigate(user.role === "admin" ? "/admin" : "/user");
    }
  }, [isAuthenticated, user, navigate]);
  const handleLoginSuccess = (role) => {
    setShowLoginModal(false);
    navigate(role === "admin" ? "/admin" : "/user");
  };

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const googleId = user.uid;

      const success = await login({
        googleId,
        role: "admin",
        username: user.displayName,
        email: user.email,
      });
      if (success) {
        handleLoginSuccess("admin");
      } else {
        alert("Login failed. Please try again.");
      }
      alert(`Welcome ${user.uid}`);
    } catch (error) {
      console.error("Login Error:", error);
      alert("Login failed. Try again.");
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-blue-700 to-emerald-600 opacity-90"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <div className="flex justify-center mb-8">
              <div className="p-4 bg-white/20 backdrop-blur-lg rounded-2xl">
                <Camera className="h-16 w-16 text-white" />
              </div>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Secure Photo Storage
            </h1>
            <p className="text-xl text-blue-100 mb-12 max-w-3xl mx-auto">
              Professional photo management with advanced security features.
              Upload, organize, and share your photos with confidence using our
              selfie verification system.
            </p>

            <div className="grid gap-6 max-w-2xl mx-auto">
              <button
                onClick={() => handleRoleSelect("admin")}
                className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1">
                <Shield className="h-12 w-12 text-white mx-auto mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="text-2xl font-bold text-white mb-2">
                  Admin Access
                </h3>
                <p className="text-blue-100">
                  Manage photos, users, and system settings
                </p>
              </button>

              {/* <button
                onClick={handleLogin}
                className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1 flex flex-col items-center">
                <img
                  src="https://www.pngplay.com/wp-content/uploads/13/Google-Logo-PNG-HD-Quality.png"
                  alt="Google Logo"
                  className="h-12 w-12 mb-4 group-hover:scale-110 transition-transform"
                />
                <h3 className="text-2xl font-bold text-white mb-2">
                  Sign in with Google
                </h3>
                <p className="text-blue-100">Login using your Gmail account</p>
              </button> */}

              {/* <button
                onClick={() => handleRoleSelect('user')}
                className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1"
              >
                <Users className="h-12 w-12 text-white mx-auto mb-4 group-hover:scale-110 transition-transform" />
                <h3 className="text-2xl font-bold text-white mb-2">User Access</h3>
                <p className="text-blue-100">View and access your photo collections</p>
              </button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Powerful Features
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need for secure photo management
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <Upload className="h-16 w-16 text-blue-600 mx-auto mb-6" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Easy Upload
              </h3>
              <p className="text-gray-600">
                Drag and drop or click to upload multiple photos with automatic
                organization
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <Eye className="h-16 w-16 text-emerald-600 mx-auto mb-6" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Smart Gallery
              </h3>
              <p className="text-gray-600">
                Beautiful gallery interface with search, filter, and sorting
                capabilities
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <Lock className="h-16 w-16 text-red-600 mx-auto mb-6" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Selfie Security
              </h3>
              <p className="text-gray-600">
                Advanced selfie verification for secure access to photo folders
              </p>
            </div>
          </div>
        </div>
      </div>

      {showLoginModal && (
        <LoginModal
          role={selectedRole}
          onClose={() => setShowLoginModal(false)}
          onSuccess={handleLoginSuccess}
        />
      )}
    </div>
  );
};

export default LandingPage;
